// extracted by mini-css-extract-plugin
export var buttonsContainer = "SocialFollowButtons-module--buttonsContainer--97395";
export var followButtonsLabel = "SocialFollowButtons-module--followButtonsLabel--16817";
export var seperated = "SocialFollowButtons-module--seperated--caba9";
export var socialFollowButtonContainer = "SocialFollowButtons-module--socialFollowButtonContainer--edabe";
export var socialMediaLink = "SocialFollowButtons-module--socialMediaLink--5b1d8";
export var tag = "SocialFollowButtons-module--tag--368cd";
export var tagsContainer = "SocialFollowButtons-module--tagsContainer--f51b2";